<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <v-layout wrap>
      <v-flex xs12 md4 order-md1>
        <SvgButtons :vistos="vistos" @showText="text=$event, $set(vistos,$event,true)"/>
      </v-flex>
      <v-flex xs12 md4 order-md0>
        <p class="texto1 animated fadeInUp" v-if="vistos[0]">
          Para las reservas, ECOPETROL S.A. atiende la normatividad SEC a través de la generación del reporte 20F de estados financieros, mientras que los recursos contingentes y los recursos prospectivos se encuentran estructurados bajo la normatividad SPE-PRMS.
        </p>
      </v-flex>
      <v-flex xs12 md4 order-md2 align-self-end>
        <p class="texto1 animated fadeInDown" v-if="vistos[1]">El informe de reservas y recursos contingentes le permite a ECOPETROL S.A. estimar oportunidades de comercialización, mientras que la estimación de recursos prospectivos identifica las oportunidades de descubrimiento y estimar oportunidades de comercialización. En los recursos prospectivos identifica las oportunidades de descubrimiento.</p>
      </v-flex>
    </v-layout>
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 2/AUDIO 11'
    ]"></audio-player> 
  </div>
</template>

<script>
import SvgButtons from '../../assets/Modulo 2/diapositiva-17'
export default {
  components:{
    SvgButtons
  },
  data() {
    return {
      dialogos: [
        "De acuerdo a lo anterior, veremos la clasificación que se desarrolla en Ecopetrol S.A. bajo la normatividad SEC y la SPE-PRMS. <span class='instruccion'>Haz clic en los cuadros de texto.</span>" 
      ],
      text: 0,
      modal: false,
      vistos: [false, false]
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  watch: {
    vistos: function(newValue){
      var todosVistos = newValue.every(el => {return el})
      if(todosVistos) {
        this.$store.commit('nextShow', true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
